import { activityFromJson, ActivityInfo } from "./activity-info.model";
import { PaginationFilterRequest } from "./core.model";

export function activityReportFromJson (json: any): ActivityReport {
  return {
    ...json,
    activity: activityFromJson(json.activity)
  } as ActivityReport;
};

export interface ActivityReport {
    id: number;
    description: string;
    startTime: Date;
    activityId: number;
    activity: ActivityInfo;
    type?: ActivityReportTypeEnum;
}

export class ActivityReportPaginationFilterRequest extends PaginationFilterRequest{  
    cityId?: number;
    countryId?: number;
    userId?: number;
    type?: ActivityReportTypeEnum;
}


export enum ActivityReportTypeEnum
{
    Country = 1,
    Marathon = 2,
    RunEvent = 3,
    DiscoveryPoint = 4,
    RunningClubEvent = 5,
}

export const ActivityReportTypeList =
[
    { value: 1, label: "Country" },
    { value: 2, label: "Marathon" },
    { value: 3, label: "Run Event" },
    { value: 4, label: "Discovery Point" },
    { value: 5, label: "Running Club Event" },
];
